import Controller, { OnClick } from '@philips-internal/oswald-ui-core/lib/client';
import { ConfigurationService, HistoryService } from '@philips-internal/oswald-ui-core/lib/services';

import { CustomRouteAliases, FragmentNames } from '../codegen';

@Controller({ fragment: FragmentNames.CUSTOM_ROUTE })
export default class CustomRouteController {

  configuration = ConfigurationService.getAuthenticationConfiguration();

  @OnClick({ target: CustomRouteAliases.GO_TO_LOGIN_BUTTON })
  onGoToLoginButtonClick(): void {
    HistoryService.push(this.configuration ? this.configuration.routes.login : '');
  }
}
